<template>
  <v-container grid-list-lg fluid>
    <v-toolbar dense flat color="grey lighten-3">
      <v-toolbar-title>Edit Department</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-row justify="end" >
        <v-col class="shrink">
          <v-btn color="pink darken-1" dark @click="submit">Update</v-btn>
        </v-col>
        <v-col class="shrink">
          <v-btn color="primary" text @click="close()">Cancel</v-btn>
        </v-col>
      </v-row>
    </v-toolbar>

    <v-card-text>
      <v-row>
        <v-col cols="12" sm="12">
          <v-text-field outlined :hide-details="nameErrors.length === 0" dense :error-messages="nameErrors"
            v-model="Class.name" label="Name"></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="6" offset-md="6">
          <v-text-field outlined dense hide-details @focus="$event.target.select()" class="right-input"
            v-model="Class.defaultFee" label="Amount"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-checkbox
            label="Collect Fees in Advance"
            hide-details
            outlined
            dense
            v-model="Class.metadata.preCollectFee"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-checkbox
            label="Count In Subscription"
            hide-details
            outlined
            dense
            v-model="Class.countInSubscription"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-checkbox
            label="Kids Class Program"
            hide-details
            outlined
            dense
            v-model="Class.isChild"
          ></v-checkbox>
        </v-col>
        <v-col cols="12">
          <v-layout row wrap align-center>
            <v-flex xs9>
              Custom Questions
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs3 shrink class="text-right">
              <v-btn color="success" @click="addRow">Add</v-btn>
            </v-flex>
          </v-layout>
        </v-col>
        <v-col cols="12">
          <draggable v-if="Class && Class.metadata && Class.metadata.customValue" tag="ul"
            :list="Class.metadata.customValue" class="list-group">
            <v-card class="mb-4" outlined v-for="(element, idx) in Class.metadata.customValue" :key="idx">
              <v-card-text>
                <v-layout row wrap align-center>
                  <v-flex xs9>
                    <v-text-field v-model="element.question" autofocus hide-details outlined dense
                      placeholder="Untitled Question"></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-select @change="dropboxCharge(element, idx)" hide-details :items="element.selectAnswerType"
                      v-model="element.selectedAnswerType" dense outlined></v-select>
                  </v-flex>
                  <v-flex xs9>
                    <v-text-field v-model="element.answer" disabled hide-details outlined
                      v-if="element.selectedAnswerType === 'Short answer'" dense
                      placeholder="Short answer text"></v-text-field>



                    <div
                      v-if="element.selectedAnswerType == 'Checkboxes' || element.selectedAnswerType == 'Multiple choice' || element.selectedAnswerType == 'Dropdown'">
                      <v-layout align-center row wrap v-for="(list, ind) in element.ChoiceList" :key="ind">
                        <v-flex shrink v-if="element.selectedAnswerType === 'Checkboxes'">
                          <v-checkbox :key="ind" readonly hide-details class="shrink mx-0"></v-checkbox>
                        </v-flex>
                        <v-flex shrink v-if="element.selectedAnswerType === 'Multiple choice'">
                          <v-radio :key="ind" readonly hide-details class="shrink mt-5"></v-radio>
                        </v-flex>
                        <v-flex>
                          <v-text-field v-model="list.label" hide-details v-if="element.ChoiceList.length > 1"
                            @click:append="removeOption(ind, element)" @focus="$event.target.select()"
                            append-icon="mdi-delete" :placeholder="list.label">
                          </v-text-field>
                          <v-text-field @focus="$event.target.select()" v-model="list.label" hide-details v-else
                            :placeholder="list.label">
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex>
                          <v-btn text @click="addInList(element)">Add option</v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-layout row wrap align-center>
                  <v-spacer></v-spacer>
                  <v-flex shrink>
                    <v-btn fab text small @click="removeQuestion(idx)">
                      <v-icon>
                        mdi-delete
                      </v-icon></v-btn>
                  </v-flex>
                  <v-divider vertical></v-divider>
                  <v-flex shrink>
                    <v-switch hide-details class="px-3 mt-0" v-model="element.isRequired" inset
                      label="Required"></v-switch>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </draggable>
        </v-col>
        <v-col cols="12">
          <v-card outlined>
            <v-card-text>
              <v-layout row wrap align-center>
                <v-flex>
                  <a :href="href" target="_blank">https://portal.taleem.app/dep/{{ currentBusiness.code }}/{{ Class.id
                    }}</a>
                </v-flex>
                <v-flex shrink>
                  <v-btn outlined small @click="copyLink" fab>
                    <v-icon small>mdi-content-copy</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12">
          <div class="mb-1">
            <div>Contact Information</div>
            <div>This information will be sent to anyone who fills out the application via email.</div>
          </div>
          <quill-editor :content="Class.contactInformation" :options="editorOption" @change="onContactInformationChange($event)" />
        </v-col>
        <v-col cols="12" sm="12">
          <div class="mb-1">
            <div>Contact Information For Pending Balance Letter</div>
            <div>This information will be sent to anyone whose balance is pending for this department.</div>
          </div>
          <quill-editor :content="Class.letterContactInformation" :options="editorOption" @change="onLetterContactInformationChange($event)" />
        </v-col>
        <v-col cols="12" sm="12">
          <div class="mb-1">Description</div>
          <quill-editor :content="Class.description" :options="editorOption" @change="onEditorChange($event)" />
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import classService from "../service.js";
import copy from "copy-to-clipboard";
import draggable from 'vuedraggable';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  props: {
    editDialog: {
      default: false,
    },
    editClass: {
      type: Object,
    },
  },
  name: "update-Class",
  data() {
    return {
      href: null,
      editorOption: {
        placeholder: 'Description',
      },
      answerType: ['Short answer', 'Paragraph', 'Checkboxes', 'Multiple choice', 'Dropdown'],
      loading: false,
      dialog: false,
      Class: {
        name: null,
        defaultFee: null,
        note: null,
        contactInformation: null,
        letterContactInformation: null,
        description: null,
        metadata: {
          customValue: [],
          preCollectFee: false,
        }
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    Class: {
      name: {
        required,
      },
    },
  },
  created() {
    this.loadData()
  },
  components: { quillEditor, draggable },
  computed: {
    ...mapGetters("global", ["currentUser", "currentBusiness"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Class.name.$dirty) return errors;
      if (!this.$v.Class.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
  },
  watch: {
    editDialog(val) {
      this.Class = this.editClass;
      this.dialog = val;
    },
  },
  methods: {
    removeOption(index, element) {
      element.ChoiceList.splice(index, 1);
    },
    removeQuestion(index) {
      this.Class.metadata.customValue.splice(index, 1);
    },
    dropboxCharge(element) {
      if (!element.ChoiceList) {
        this.addValueToList(element);
      }
    },
    addValueToList(element) {
      if (!element.ChoiceList) {
        this.$set(element, 'ChoiceList', []);
      }
      element.ChoiceList.push({ label: `Option ${element.ChoiceList.length + 1}`, answer: null });
    },
    addRow() {
      if (!this.Class.metadata) {
        this.$set(this.Class, 'metadata', {});
      }

      if (!Object.prototype.hasOwnProperty.call(this.Class.metadata, 'customValue')) {
        console.log('customValue not found');
        this.$set(this.Class.metadata, 'customValue', []);
      }

      this.Class.metadata.customValue.push({
        question: null,
        answer: null,
        selectAnswerType: this.answerType,
        selectedAnswerType: 'Short answer',
        isRequired: false,
      });
    },
    addInList(element) {
      this.addValueToList(element);
    },
    copyLink() {
      copy(this.href);
      this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000
        })
        .fire({
          icon: "success",
          title: "Link is copy!"
        });
    },
    close() {
      this.empty();
      this.$router.go(-1)
    },
    loadData() {
      const { id } = this.$route.params;
      return classService.getById(id).then((response) => {
        this.Class = response.data;
        this.href = `https://portal.taleem.app/dep/${this.currentBusiness.code}/${this.Class.id}`
        if (this.Class && !this.Class.metadata) {
          this.Class.metadata = {
            customValue: [],
            preCollectFee: false
          }
        } else if(this.Class.metadata){
          if(!Object.prototype.hasOwnProperty.call(this.Class.metadata, 'customValue')){
            this.Class.metadata.customValue = []
          }
          if(!Object.prototype.hasOwnProperty.call(this.Class.metadata, 'preCollectFee')){
            this.Class.metadata.preCollectFee = false
          }
        }
        console.log('response', response)
        return response;
      }).catch((error) => {
        console.log("error", error);
      });
    },
    empty() {
      this.Class = {
        name: null,
        defaultFee: null,
        note: null,
        contactInformation: null,
        letterContactInformation: null,
        description: null,
        metadata: {
          customValue: [],
          preCollectFee: false,
        }
      };
      this.$v.$reset();
    },
    onEditorChange(value) {
      this.Class.description = value.html
    },
    onContactInformationChange(value) {
      this.Class.contactInformation = value.html
    },
    onLetterContactInformationChange(value) {
      this.Class.letterContactInformation = value.html
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        if (this.Class && this.Class.metadata && this.Class.metadata.customValue) {
          this.Class.metadata.customValue = this.Class.metadata.customValue.filter(row => row.question);
        }
        return classService.update(this.Class.id, this.Class)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Department is updated",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>